<div class="p-1">
	<mat-expansion-panel [expanded]="true" [hideToggle]="hideExpansionToggle" class="mat-elevation-z8">
		<mat-expansion-panel-header [ngClass]="{'disabled-pointer': hideExpansionToggle}">
			<mat-panel-title>
				<h3> {{ filterSectionTitle }} </h3>
			</mat-panel-title>
		</mat-expansion-panel-header>

		<mat-divider></mat-divider>
		<form [formGroup]="form" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="3% 0% grid"
			fxLayoutGap.lt-md="1%" class="dark-background-search-form white-mat-form-field-form w-100">
			<div *ngFor="let filter of filters; let i = index" [fxFlex]="filter.flexSize" fxFlex.lt-md="100%">
				<!-- Simple input field -->
				<mat-form-field *ngIf="filter.type === 'input'" appearance="outline" class="w-100">
					<mat-label>{{ filter.name }}</mat-label>
					<input matInput [formControlName]="filter.id" />
					<mat-error *ngIf="form.controls[filter.id].hasError('matDateInvalid')">
						Invalid {{ filter.name }} date
					</mat-error>
					<mat-error *ngIf="form.controls[filter.id].hasError('required')">
						{{ filter.name }} is required!
					</mat-error>
				</mat-form-field>

				<!-- Simple date field -->
				<mat-form-field *ngIf="filter.type === 'date' && !filter.datePickerRange" appearance="outline"
					class="w-100">
					<mat-label>{{ filter.name }}</mat-label>
					<input matInput [formControlName]="filter.id" [matDatepicker]="datePicker_i">
					<mat-datepicker-toggle matSuffix [for]="datePicker_i"></mat-datepicker-toggle>
					<mat-datepicker #datePicker_i></mat-datepicker>
					<mat-error *ngIf="form.controls[filter.id].hasError('matDateInvalid')">
						Invalid {{ filter.name }} date
					</mat-error>
					<mat-error *ngIf="form.controls[filter.id].hasError('required')">
						{{ filter.name }} is required!
					</mat-error>
				</mat-form-field>

				<!-- Range date field -->
				<mat-form-field *ngIf="filter.type === 'date' && filter.datePickerRange" appearance="outline"
					class="w-100">
					<mat-label>{{ filter.name }}</mat-label>
					<mat-date-range-input [min]="filter.minDateValue" [rangePicker]="datePicker_i">
						<input matStartDate [formControlName]="filter.id + 'Start'"
							[placeholder]="filter.name + ' Start'" />
						<input matEndDate [formControlName]="filter.id + 'End'" [placeholder]="filter.name + ' End'" />
					</mat-date-range-input>
					<mat-datepicker-toggle matSuffix [for]="datePicker_i"></mat-datepicker-toggle>
					<mat-date-range-picker #datePicker_i></mat-date-range-picker>
					<mat-error *ngIf="
						form.controls[filter.id + 'Start']?.hasError(
							'matStartDateInvalid'
						) ||
						form.controls[filter.id + 'End']?.hasError(
							'matEndDateInvalid'
						)
					">
						Invalid {{ filter.name }} Start/End date
					</mat-error>
					<mat-error *ngIf="form.controls[filter.id + 'Start']?.hasError('matDatepickerMin')">
						The {{ filter.name }} Start/End Date needs to be higher or equal than {{ filter.minDateValue | date:'MM/dd/yyyy' }}
					</mat-error>
					<mat-error *ngIf="form.controls[filter.id + 'Start'].hasError('required')">
						{{ filter.name }} is required!
					</mat-error>
				</mat-form-field>

				<!-- Simple multipleselect field -->
				<mat-form-field *ngIf="filter.type === 'select'" appearance="outline" class="w-100">
					<mat-label>{{ filter.name }}</mat-label>
					<mat-select [formControlName]="filter.id" [multiple]="filter.multipleSelect" panelWidth=""
						(selectionChange)="emitChange($event.value, filter.id)">
						<app-select-check-all *ngIf="filter.selectAll" [model]="form.get(filter.id)"
							[values]="filter.values" [idField]="filter.values[0]?.value ? 'value' : null">
						</app-select-check-all>
						<mat-option (onSelectionChange)="$event.isUserInput ? emitClear(filter.id) : undefined"
							*ngIf="!filter.selectAll && !filter.required">No selection</mat-option>
						<mat-option *ngFor="let value of filter.values" [value]="value?.value ? value.value : value">
							{{ value?.display ? value.display : value }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.controls[filter.id].hasError('required')">
						{{ filter.name }} is required!
					</mat-error>
				</mat-form-field>

				<!-- Autocomplete field -->
				<mat-select-autocomplete *ngIf="filter.type === 'autocomplete'" [appearance]="'outline'"
					[placeholder]="filter.name" [options]="refModels.get(filter.id).options"
					[multiple]="filter.multipleSelect" [selectAll]="filter.selectAll" [name]="filter.id"
					ngDefaultControl [selectedOptions]="filter.defaultValues"
					[filterInput]="refModels.get(filter.id).inputSearch" [formControl]="form.controls[filter.id]"
					(selectionChange)="emitChange($event, filter.id)" (clear)="emitClear(filter.id)" class="w-100">
				</mat-select-autocomplete>
			</div>
			<span class="cdk-visually-hidden"></span>
		</form>
		<mat-action-row fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center"
			fxLayoutAlign.lt-md="center stretch" fxLayoutGap="2%" fxLayoutGap.lt-md="1%"
			*ngIf="!notEditable || customButtons?.length">
			<button mat-raised-button color="primary" *ngIf="!notEditable" [fxFlex]="searchFlexSize" fxFlex.lt-md="100%"
				(click)="onSearch()"> {{ searchLabel
				}}</button>
			<button mat-raised-button *ngIf="hasExport" color="primary" fxFlex="15%" fxFlex.lt-md="100%"
				(click)="onExport()">Export</button>
			<ng-container *ngFor="let button of customButtons">
				<button mat-raised-button color="primary" [disabled]="button.disabled" [fxFlex]="button.flexSize"
					fxFlex.lt-md="100%" (click)="doCustomAction(button)" *appUserRole="buildGuardParamRole(button)">{{
					button.name
					}}</button>
			</ng-container>
			<button mat-button *ngIf="!notEditable" fxFlex="15%" fxFlex.lt-md="100%" color="accent" (click)="clear()">
				<mat-icon style="font-size: 20px">close</mat-icon>Clear</button>
		</mat-action-row>
	</mat-expansion-panel>
</div>